import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { Base } from '../base';

export class PoolSnapshots extends Base {
  constructor(protected httpClient: HttpClient, private parent: string) {
    super(httpClient, `${parent}/pool_snapshots`);
  }

  query(params?: any) {
    return this.api.query(params).pipe(
      tap((json) => json.poolSnapshots.forEach((record: any) => this.processRecord(record)))
    );
  }

  private processRecord(record: any) {
    record.apy = record.apy * 100;
    record.avgApy = record.avgApy * 100;
  }
}
